import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { Text, TextType } from 'ui-components/components/text';
import { NotificationService, NOTIFICATION_TYPE_ERROR, NOTIFICATION_TYPE_WARNING } from 'ui-components/services/notification-service';

import { useModal } from '../../hooks/use-modal';
import { VerifiedMerchantRequestModal } from '../modals/verified-merchant-request-modal';

const messages = defineMessages({
  warningTitle: {
    description: 'Title of notification warning users to contact support to increase spending limit',
    // oxlint-disable-next-line no-template-curly-in-string
    defaultMessage: 'Your account currently has a ${limit} spending limit',
    id: 'TYaVBZ',
  },
  messageBody: {
    description: 'Body of notification telling users to contact support to increase spending limit',
    defaultMessage:
      // oxlint-disable-next-line no-template-curly-in-string
      'Become a verified merchant to remove the ${limit} spending limit from your account.',
    id: 'USRRZR',
  },
  errorTitle: {
    description: 'Title of notification letting users know they hit their spending limit',
    // oxlint-disable-next-line no-template-curly-in-string
    defaultMessage: "You've reached your ${limit} spending limit",
    id: 'sqm3HT',
  },
  viewInstructions: {
    description: 'Button text for opening the request modal',
    defaultMessage: 'Verify Now',
    id: 'k0YT6b',
  },
});

const NotificationLimitBody = ({ limit }) => {
  const { close, isOpen, open } = useModal();
  return (
    <div>
      <Text formattedMessageValues={{ limit }} textType={TextType.Paragraph} value={messages.messageBody} />
      <Button onClick={open} theme='tertiary'>
        <FormattedMessage {...messages.viewInstructions} />
      </Button>
      {isOpen ? <VerifiedMerchantRequestModal onClose={close} /> : null}
    </div>
  );
};

export const ShowSpendingLimitNotification = async ({ homeCountry, result }) => {
  if (homeCountry !== 'US') {
    return;
  }
  const { limitRemaining, limit, trustLevel } = result || {};
  // the undefined case is when we get 204 from the response, indicating they have no wallet
  if (trustLevel === 'Trusted' || trustLevel === undefined) {
    return;
  }

  const showError = limitRemaining <= 5;

  NotificationService.showNotification({
    notificationType: showError ? NOTIFICATION_TYPE_ERROR : NOTIFICATION_TYPE_WARNING,
    title: <FormattedMessage {...(showError ? messages.errorTitle : messages.warningTitle)} values={{ limit }} />,
    content: <NotificationLimitBody limit={limit} />,
  });
};
